<template>
  <g-popup title="확인" :background-click="false" >
    <template #body>
      <div class="-wrapper -py-5">
        <h3 class="-h3 -font-weight-regular">{{text}}</h3>
      </div>
    </template>
    <template #footer>
      <g-button variant="borderless" @click="onClickCancel"><span>취소</span></g-button>
      <g-button variant="primary" @click="onClickConfirm"><span>확인</span></g-button>
    </template>
  </g-popup>
</template>

<script>
export default {
  props: {
    instKey: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      defalut: () => () => {}
    },
    onCancel: {
      type: Function,
      defalut: () => () => {}
    }
  },
  methods: {
    onClickConfirm () {
      this.$popupManager.close(this.instKey)
      if (this.onConfirm) {
        this.onConfirm()
      }
    },
    onClickCancel () {
      this.$popupManager.close(this.instKey)
      if (this.onCancel) {
        this.onCancel()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/components/ConfirmPopup.vue